export const statusErrorsMessages = {
  IncorrectAccount: 'Incorrect account for this profile',
  IncorrectAdvertiser: 'Incorrect advertiser for this profile',
  IncorrectAttributionModel: 'Incorrect attribution model for this profile',
  IncorrectProfileForAdvertiser:
    'This Profile ID doesn’t have access to Advertiser ID. Choose another Profile ID',
};
